import { render, staticRenderFns } from "./BottomMain.vue?vue&type=template&id=7bd4265a&scoped=true&"
import script from "./BottomMain.vue?vue&type=script&lang=ts&"
export * from "./BottomMain.vue?vue&type=script&lang=ts&"
import style0 from "./BottomMain.vue?vue&type=style&index=0&id=7bd4265a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd4265a",
  null
  
)

export default component.exports